import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  dateDifferenceInDaysFromToday,
  formatUSD
} from '../../helpers/helperFunctions';
import { CaptionText, H3, P1, P3 } from '../../styles/FontStyles';
import { Button, Flexed } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import {
  Icon,
  IconPortfolioDiamond,
  IconPortfolioOffice,
  IconPortfolioOrders
} from '../../styles/Icons';
import { BoxPortfolio, SummaryGrid } from './Portfolio.styled';
import { UserTypes } from '../../types/loginTypes';
import { useEffect } from 'react';

export const MembershipStatus = () => {
  const { t } = useTranslation('my_hubs');
  const dispatch = useAppDispatch();
  const history = useHistory();

  const { currentVirtualOfficeLicence } = useAppSelector(
    (state) => state.portfolio
  );

  const { userInfo } = useAppSelector((state) => state.auth);
  const { walletSummary } = useAppSelector((state) => state.portfolio);

  const isRestrictedUser = userInfo.userType === UserTypes.Restricted;

  return (
    <>
      <Flexed mb='20' mt='20' between alignEnd>
        <H3>{t('my_membership_status')}</H3>
      </Flexed>

      <SummaryGrid>
        <BoxPortfolio hasButton>
          <Flexed center>
            <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
              <IconPortfolioOffice />
            </Icon>
            <div>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('backoffice_subscription')}
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {dateDifferenceInDaysFromToday(
                  currentVirtualOfficeLicence?.dateEnd
                )}
                <P3 mb='1'>{t('days_left')}</P3>
              </P1>
            </div>
          </Flexed>
          {!isRestrictedUser && (
            <Button
              w='100px'
              h='34px'
              onClick={() =>
                history.push('/backoffice/settings/virtual-office')
              }>
              {t('add_time')}
            </Button>
          )}
        </BoxPortfolio>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioOrders />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              {t('total_personal_orders')}
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {formatUSD(walletSummary?.totalOrder)} <P3 mb='1'>USDT</P3>
            </P1>
          </div>
        </BoxPortfolio>
      </SummaryGrid>
    </>
  );
};
